export enum MobileIso {
  Italy = 'it-IT',
  UnitedKingdom = 'en-GB',
  Egypt = 'ar-EG',
  UAE = 'ar-AE'
}
